import React from 'react';
import { FormLayout, ProfileForm } from '../../containers';
import useStyle from './ProfilePageStyle';
import { ConsentDecorator } from '../../components/RoutesDecorator/ConsentDecorator';

const ProfilePage: React.FC = () => {
    const style = useStyle();

    return (
        <ConsentDecorator>
            <FormLayout>
                <div className={style.profile_page}>
                    <ProfileForm />
                </div>
            </FormLayout>
        </ConsentDecorator>
    );
};

export default ProfilePage;
